import { useContent } from "@/context/ContentContext";

const SERVICE_NAMES = {
  "/nri-parent-care": "NRI Parent Care",
  "/nri-property-management": "NRI Property Management",
};

export const PageSeo = ({ path, faqs }) => {
  const { content } = useContent();
  const seo = (content.seo && content.seo[path]) || {};
  const b = content.business || {};
  const siteUrl = (b.website_url || "https://www.tricityfamilyconcierge.com").replace(/\/$/, "");
  const pageUrl = seo.canonical || `${siteUrl}${path === "/" ? "/" : path}`;
  const ogImage = seo.og_image
    ? seo.og_image.startsWith("http")
      ? seo.og_image
      : `${siteUrl}${seo.og_image}`
    : `${siteUrl}/images/hero-parents.jpg`;

  const graph = [
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      name: b.name || "Tricity Family Concierge",
      url: siteUrl,
      description: b.description || undefined,
      contactPoint: {
        "@type": "ContactPoint",
        telephone: b.phone_display,
        contactType: "customer service",
        areaServed: ["Chandigarh", "Mohali", "Panchkula"],
      },
    },
    {
      "@type": "LocalBusiness",
      "@id": `${siteUrl}/#business`,
      name: b.name || "Tricity Family Concierge",
      url: siteUrl,
      telephone: b.phone_display,
      description: b.description || undefined,
      areaServed: [
        { "@type": "City", name: "Chandigarh" },
        { "@type": "City", name: "Mohali" },
        { "@type": "City", name: "Panchkula" },
      ],
    },
  ];

  if (SERVICE_NAMES[path]) {
    graph.push({
      "@type": "Service",
      name: SERVICE_NAMES[path],
      provider: { "@id": `${siteUrl}/#organization` },
      areaServed: ["Chandigarh", "Mohali", "Panchkula"],
      url: pageUrl,
      description: seo.description || undefined,
    });
  }

  if (faqs && faqs.length) {
    graph.push({
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
  }

  return (
    <>
      {seo.title && <title>{seo.title}</title>}
      {seo.description && <meta name="description" content={seo.description} />}
      <link rel="canonical" href={pageUrl} />
      {seo.noindex && <meta name="robots" content="noindex, nofollow" />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && <meta property="og:description" content={seo.description} />}
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">{JSON.stringify({ "@context": "https://schema.org", "@graph": graph })}</script>
    </>
  );
};
